import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import StarIcon from '@mui/icons-material/Star';
import CloseIcon from '@mui/icons-material/Close';
import { useFavouriteRunners } from '../context/FavouriteRunnersContext';

import { Filter } from './Filter';
import { MeetingListWithPopup } from "./Meetings";
import { FixedLeaderboard } from "./Records";
import { Achievements } from "./Runner";
import { ISIOSWEB, ISANDROIDWEB, getRunner } from "./Util";
import { ABar, ExpandableSection, TBar, Title } from "./Widgets";
import DRIcon from '../images/DRLogo2.png';
import ParkrunLogo from '../images/parkrun-logo.png';
import AppStoreIcon from '../images/applestore.png';
import GooglePlayIcon from '../images/googleplay.png';
import { IconButton, FormControlLabel, Checkbox } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useGlobalContext } from '../hooks/useGlobalContext';
import './Home.css';

export function Home() {
  const { menuOpen, setMenuOpen } = useGlobalContext();
  const [byVenue, setByVenue] = useState(false);
  const navigate = useNavigate();
  const { favourites, removeFavourite } = useFavouriteRunners();

  const openMenu = () => {
    setMenuOpen(!menuOpen)
  }

  var appbar =
    <ABar position='top'>
      <TBar>
        <IconButton sx={{ color: "var(--paper-color)" }} onClick={openMenu}>
          <MenuIcon fontSize="large"></MenuIcon>
        </IconButton>
        <img className='icon' src={DRIcon} alt="Dulwich Runners" />
        <div className='largetext title-on-dark'>
          Dulwich Runners
        </div>
      </TBar>
    </ABar>

  // When we use a web browser on a device (instead of using the App) we show a link to download the App
  var appLink = <></>
  var style = { width: '50%', verticalAlign: 'middle', padding: '16px' };
  if (ISIOSWEB) {
    appLink = <a href="https://apps.apple.com/us/app/drastic-run/id1617116978">
      <img alt='Download on the App Store' src={AppStoreIcon} style={style} />
    </a>
  } else if (ISANDROIDWEB) {
    appLink = <a href='https://play.google.com/store/apps/details?id=run.drastic'>
      <img alt='Get it on Google Play' src={GooglePlayIcon} style={style} />
    </a>
  }

  const favouriteRunnerList = favourites
    .map(id => ({ id, runner: getRunner(id) }))
    .filter(item => item.runner !== undefined);

  var now = new Date();
  var start_date = new Date(now);
  start_date.setMonth(start_date.getMonth() - 1);
  
  var filter = Filter.DateRangeFilter(start_date, now, 'parkrun', '', '', false, '');
  const parkrunReports = <FixedLeaderboard key={`parkrun_${1}`} filter={filter} rID="" variant="simple"
                            start_open={false} title={"Parkrun Reports"} split={true} byVenue={byVenue} />

  // Achievements and other results from the last 2-3 months
  start_date = new Date(now);
  start_date.setDate(1);
  start_date.setMonth(start_date.getMonth() - 2);
  filter = Filter.DateRangeFilter(start_date, now, 'notparkrun', '', '', false, '')
  var others = <MeetingListWithPopup 
                  filter={Filter.get_params(filter)} 
                  start_grouped={true} 
                  group_by='M' 
                  print={false}
                  deepLinkBase="/races"
                />

  filter = Filter.DateRangeFilter(start_date, now, '', '', '', false, '')
  var achievements = <Achievements filter={Filter.get_params(filter)} />

  const fav_block = favouriteRunnerList.length > 0 && (
                        <div className={'paper dr-home-other-results-container'}>
                          <Title text="Favourite Runners" />

                          {favouriteRunnerList.map(({ id, runner }) => (
                            <div
                              key={id}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                padding: '8px 12px',
                              }}
                            >
                              <StarIcon fontSize="small" />

                              <span
                                className="link"
                                onClick={() => navigate(`/runners/${id}`)}
                                style={{ flexGrow: 1 }}
                              >
                                {runner.First} {runner.Last} ({runner.Gender} {runner.AG})
                              </span>

                              <IconButton
                                size="small"
                                onClick={() => removeFavourite(id)}
                                aria-label="Remove favourite runner"
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </div>
                          ))}
                        </div>
                      );

  const parkrun_block = (      <div className={'paper dr-home-weekly-container'}>
                            <div className="flexcard" style={{ justifyContent: 'space-between', padding: '4px 8px', }}>
                                      <img
                                        src={ParkrunLogo}
                                        alt="parkrun"
                                        style={{
                                            height: '72px',
                                            width: 'auto',
                                            display: 'block',
                                          }}
                                      />

                                      <FormControlLabel
                                        control={<Checkbox />}
                                        label="By venue"
                                        onChange={() => setByVenue(!byVenue)}
                                        checked={byVenue}
                                      />
                            </div>
                            <div style={{padding: '0px'}}>
                              {parkrunReports}
                            </div>
                          </div>
                    )

  const achievements_block = (      <div className={'paper dr-home-other-results-container'}>
                          <div style={{padding: '0px'}}>
                            <ExpandableSection title="Recent Personal and Season Best" details={''}>
                              {achievements}
                            </ExpandableSection>
                          </div>
                        </div>
                    )

  const results_block = (      <div className={'paper dr-home-other-results-container'}>
                          <Title text="Race Results" />
                          {others}
                        </div>
                    )

  return <div>
    {appbar}
    {appLink}
    <div className={'dr-home-container'}>
      {fav_block}
      {results_block}
      {parkrun_block}
      {achievements_block}
    </div>
  </div>
}
